import type { PinOutcome } from "@/hooks/useCanvassing";

export const PIN_OUTCOMES: Record<PinOutcome, { label: string; color: string; emoji: string }> = {
  not_knocked: { label: "Not Knocked", color: "bg-muted text-muted-foreground", emoji: "⬜" },
  not_home: { label: "Not Home", color: "bg-yellow-500/20 text-yellow-700 dark:text-yellow-400", emoji: "🏠" },
  not_interested: { label: "Not Interested", color: "bg-red-500/20 text-red-700 dark:text-red-400", emoji: "❌" },
  callback: { label: "Callback", color: "bg-blue-500/20 text-blue-700 dark:text-blue-400", emoji: "📞" },
  appointment_set: { label: "Appointment Set", color: "bg-green-500/20 text-green-700 dark:text-green-400", emoji: "📅" },
  sold: { label: "Sold!", color: "bg-emerald-500/20 text-emerald-700 dark:text-emerald-400", emoji: "💰" },
  already_customer: { label: "Already Customer", color: "bg-purple-500/20 text-purple-700 dark:text-purple-400", emoji: "⭐" },
};

export const PIN_MARKER_COLORS: Record<PinOutcome, string> = {
  not_knocked: "#94a3b8",
  not_home: "#eab308",
  not_interested: "#ef4444",
  callback: "#3b82f6",
  appointment_set: "#22c55e",
  sold: "#10b981",
  already_customer: "#a855f7",
};

export function getCanvassingStats(pins: Array<{ outcome: PinOutcome }>) {
  const total = pins.length;
  const knocked = pins.filter(p => p.outcome !== "not_knocked").length;
  const appointments = pins.filter(p => p.outcome === "appointment_set" || p.outcome === "sold").length;
  const sold = pins.filter(p => p.outcome === "sold").length;
  const callbacks = pins.filter(p => p.outcome === "callback").length;
  const notHome = pins.filter(p => p.outcome === "not_home").length;

  return {
    total,
    knocked,
    appointments,
    sold,
    callbacks,
    notHome,
    conversionRate: knocked > 0 ? Math.round((appointments / knocked) * 100) : 0,
    closeRate: appointments > 0 ? Math.round((sold / appointments) * 100) : 0,
  };
}
